




















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ActivitySessionGameTable from '@activities/components/tables/activity-session-game-table/activity-session-game-table.vue';
import { Activity } from '@activities/interfaces/activity';
@Component({
  name: 'activity-session-game-table-input',
  components: { ActivitySessionGameTable },
})
export default class ActivitySessionGameTableInput extends Vue {
  @Prop({ type: String, default: 'calendar' }) readonly typeOfDisplay: string;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly filters: any[];
  @Prop({ type: Boolean, default: true }) readonly ignoreURLParams: boolean;
  @Prop({ type: String, default: 'table' }) readonly displayConfigName: string;
  @Prop({ type: String, default: 'default' }) readonly filterConfigName: string;
  @Prop({ type: String, default: 'default' }) readonly formConfigName: string;
  @Prop({ type: String, default: 'edit' }) readonly editFormConfigName: string;
  @Prop({ type: String, default: 'cancel-activity-session-game' })
  readonly cancelFormConfigName: string;
  @Prop({ type: Array, default: null }) readonly selectConfigName: string[];
  @Prop({ type: Boolean, default: true }) readonly showCalendarActivityFilter: boolean;
  @Prop({ type: Boolean, default: true }) readonly showCalendarTeamFilter: boolean;
  @Prop({ type: Boolean, default: false }) readonly showHeader: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabled: boolean;
  @Prop(Object) readonly formModel: object;

  activity: Activity = null;

  setActivity($event) {
    this.activity = $event;
  }
}
